import {appEnv} from '@/appEnv'
import {EScene} from '@/types/scene.types'
import {useGSAP} from '@gsap/react'
import {BackButton} from '@repo/shared/Customer/Coop/BackButton/BackButton'
import {ContentWidthLimiter} from '@repo/shared/Customer/Coop/ContentWidthLimiter/ContentWidthLimiter'
import {getGameMode} from '@repo/shared/Customer/Coop/utils/gameCodeTypes'
import JoinCode from '@repo/shared/JoinCode/JoinCode'
import {useTracking} from '@repo/shared/Tracking/Tracking.hooks'
import {getTrackingGameMode} from '@repo/shared/Tracking/Tracking.utils'
import {useWakeLockContext} from '@repo/shared/WakeLockProvider'
import clsx from 'clsx'
import gsap from 'gsap'
import {useAtomValue} from 'jotai'
import {useEffect, useRef} from 'react'
import {useReset} from '../Reset/Reset.hooks'
import {gameCodeState, gameModeState, sceneState} from '../Store/atoms'
import FrameStore from '../Store/FrameStore'

const fStore = new FrameStore()

const LobbyParty = () => {
  const {requestWakeLock} = useWakeLockContext()
  const {resetAll} = useReset()
  const {trackEvent} = useTracking()

  const gameCode = useAtomValue(gameCodeState)
  const scene = useAtomValue(sceneState)
  const gameMode = useAtomValue(gameModeState)

  const screenRef = useRef<HTMLDivElement>(null)
  const joinCodeRef = useRef<HTMLDivElement>(null)

  // animate the lobby out of screen in pararell with the camera pan down
  useGSAP(
    () => {
      if (scene === EScene.STARTED_COUNTDOWN) {
        const timeline = gsap.timeline()
        timeline.to(screenRef.current, {top: '-100%', duration: 1, ease: 'power1.in'})
        timeline.play()
      } else if (scene === EScene.LOBBY) {
        gsap.set(screenRef.current, {top: '0%'})
        gsap.to(joinCodeRef.current, {opacity: 1, duration: 0.4, ease: 'power1.in'})
      }
    },
    {
      dependencies: [scene],
    },
  )

  useEffect(() => {
    requestWakeLock()
  }, [requestWakeLock])

  if (!(scene === EScene.LOBBY || scene === EScene.STARTED_COUNTDOWN)) {
    return null
  }

  return (
    <ContentWidthLimiter id="lobby">
      {gameCode && getGameMode(gameCode.toString()) === 'party' && (
        <BackButton
          onClick={() => {
            trackEvent({
              domain: EScene.LOBBY,
              trigger: 'click',
              source: 'back_button',
              meta: {
                gameMode: getTrackingGameMode(gameMode),
              },
            })

            resetAll()
          }}
        />
      )}
      <div
        className={clsx(
          'fixed left-0 top-0 z-30 flex h-full w-full flex-col items-center justify-center gap-12 pb-[12vh] pt-[18vh] backdrop-blur-sm transition-[backdrop-filter] duration-1000',
          scene === EScene.STARTED_COUNTDOWN && 'backdrop-blur-0',
        )}
        ref={screenRef}
      >
        <img className="w-[420px]" src="assets/logo.svg" />

        <div
          className="items-between flex flex-col justify-center gap-8 opacity-0"
          ref={joinCodeRef}
        >
          <JoinCode url={appEnv.CONTROLLER_URL ?? 'missing CONTROLLER_URL env'} code={gameCode} />
        </div>
      </div>
    </ContentWidthLimiter>
  )
}

export default LobbyParty
